// extracted by mini-css-extract-plugin
module.exports = {"SelectNewsletters":"SelectNewsletters_SelectNewsletters__1CDf4"};